import React from 'react'
import DealingsNavigator from "../../components/DealingsNavigator";
import getObjectValue from "libs/getObjectValue";
import {FieldArray} from "formik";
import NoticeObjectDividedList from "./NoticeObjectDividedList";


function NoticeObjectDivided(
    {
        id,
        formikProps
    }) {
    const getItems = () => getObjectValue(id, formikProps.values, []);
    const curIndex = getObjectValue('noticeObjectDealing', formikProps.values, -1);

    

    return (<FieldArray
        name={id}
        render={(arrayHelpers) => (<>
            <DealingsNavigator
                formikProps={formikProps}
                id="noticeObjectDealing"
                items={getItems()}
            />
            {curIndex > -1 &&
                <NoticeObjectDividedList
                    formikProps={formikProps}
                    id={id + "." + curIndex}
                    index={curIndex}
                />
            }
        </>)}
    />)
}

NoticeObjectDivided.propTypes = {};

export default NoticeObjectDivided;
